// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { apiurl } from "../config/config";
// import { BiError } from "react-icons/bi";
// import { BlinkLoader } from "../components/loader";
// import { setCookie } from "../config/webStorage.js";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { GoArrowRight } from "react-icons/go";

// const UserLogin = () => {
//     const [password, setPassword] = useState("");
//     const [email, setEmail] = useState("");
//     const [error, setError] = useState("");
//     const [loginloading, setLoginLoading] = useState(false);
//     const [showPassword, setShowPassword] = useState(false);
//     const [rememberMe, setRememberMe] = useState(false);

//     const navigate = useNavigate();

//     const loginHandler = async (e) => {
//         e.preventDefault();
//         if (!email) return setError("Please enter email address");
//         if (!password) return setError("Please enter password");
//         try {
//             setLoginLoading(true);
//             const response = await axios.post(`${apiurl}/api/user/login`, {
//                 email,
//                 password,
//             });
//             if (!response.data.success) {
//                 setError(response.data.message);
//             } else {
//                 const token = rememberMe ? response.data.refreshToken : response.data.accessToken;
//                 setCookie("swtoken", token, rememberMe ? 2505600 : 25200);
//                 navigate("/lander");
//             }
//         } catch (error) {
//             setError("Login failed. Please try again.");
//         } finally {
//             setLoginLoading(false);
//         }
//     };

//     return (
//         <div className="w-full min-h-screen flex justify-center bg-[#fffdfc] items-center p-4 md:p-10">
//             <div className="w-full max-w-4xl flex flex-col md:flex-row border border-[#39160D] shadow-lg rounded-lg overflow-hidden">
//                 <div className="w-full md:w-1/2 flex flex-col justify-center p-6">
//                 <div className="flex justify-center items-center">
//                 <img src="/suwasthi-logo-brown.png" alt="Logo" className="h-24 mb-6" height={100}/>
//                 </div>
//                     <h2 className="text-2xl font-semibold text-gray-800 mb-2 text-center">Welcome back!</h2>
//                     <p className="text-gray-500 mb-8 text-center">Please login to your account</p>

//                     <form onSubmit={loginHandler} className="space-y-4">
//                         <div>
//                             <label className="text-[#575757] font-medium text-sm">Email Address</label>
//                             <input
//                                 type="email"
//                                 placeholder="Email"
//                                 className="w-full px-4 py-3 bg-[#f4f2f0] focus:outline-none focus:ring-1 focus:ring-[#d8c9ae] rounded-md"
//                                 value={email}
//                                 onChange={(e) => {
//                                     setEmail(e.target.value);
//                                     setError("");
//                                 }}
//                             />
//                         </div>
//                         <div>
//                             <label className="text-[#575757] font-medium text-sm">Password</label>
//                             <div className="relative">
//                                 <input
//                                     type={showPassword ? "text" : "password"}
//                                     placeholder="Password"
//                                     className="w-full px-4 py-3 bg-[#f4f2f0] focus:outline-none focus:ring-1 focus:ring-[#d8c9ae] rounded-md"
//                                     value={password}
//                                     onChange={(e) => {
//                                         setPassword(e.target.value);
//                                         setError("");
//                                     }}
//                                 />
//                                 <button
//                                     type="button"
//                                     className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
//                                     onClick={() => setShowPassword(!showPassword)}
//                                 >
//                                     {showPassword ? <FaEye /> : <FaEyeSlash />}
//                                 </button>
//                             </div>
//                         </div>

//                         {error && (
//                             <div className="text-red-500 text-sm flex items-center gap-2">
//                                 <BiError /> {error}
//                             </div>
//                         )}

//                         <div className="flex items-center justify-between">
//                             <label className="flex items-center cursor-pointer">
//                                 <input
//                                     type="checkbox"
//                                     className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
//                                     checked={rememberMe}
//                                     onChange={() => setRememberMe(!rememberMe)}
//                                 />
//                                 <span className="ml-2 text-sm text-gray-600">Remember Me</span>
//                             </label>
//                             <Link to="/reset-password" className="text-sm text-slate-600 hover:text-[#d8c9ae] font-medium">
//                                 Forgot Password?
//                             </Link>
//                         </div>

//                         <button
//                             type="submit"
//                             className="w-full bg-[#39160D] font-semibold text-[#d8c9ae] hover:bg-[#494949] h-11 flex items-center justify-center rounded-md transition duration-200"
//                             disabled={loginloading}
//                         >
//                             {loginloading ? (
//                                 <BlinkLoader />
//                             ) : (
//                                 <span className="flex items-center">
//                                     Sign In
//                                     <GoArrowRight className="ml-2 transition-transform duration-300 group-hover:translate-x-2" />
//                                 </span>
//                             )}
//                         </button>
//                     </form>

//                     <p className="text-sm text-gray-600 mt-6">
//                         Don't have an account yet? {" "}
//                         <Link to="/signup" className="text-sm text-slate-600 hover:text-[#d8c9ae] font-medium">
//                             Sign up
//                         </Link>
//                     </p>
//                 </div>

//                 <div className="hidden md:block md:w-1/2">
//                     <img src="/images/COLLAGE-BANNER.jpg" alt="Banner" className="w-full h-full object-cover" />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default UserLogin;

import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { apiurl } from "../config/config";
import { BiError } from "react-icons/bi";
import { BlinkLoader } from "../components/loader";
import { getCookie, removeCookie, setCookie } from "../config/webStorage.js";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { GoArrowRight } from "react-icons/go";
import { validateToken } from "../config/validateToken.js";
import { useUser } from "../config/userProvider.js";

const UserLogin = () => {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loginloading, setLoginLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const redirectTo = params.get("redirect"); // e.g. "/applications/123/manage"

  const navigate = useNavigate();
  const { setUser } = useUser();

  useEffect(() => {
    const token = getCookie("swtoken");
    if (!token) return;

    validateToken(token)
      .then((res) => {
        if (res?.success) {
          setUser(res.data);
          navigate("/lander"); // 🚀 redirect dashboard if valid
        } else {
          removeCookie("swtoken");
        }
      })
      .catch(() => removeCookie("swtoken"));
  }, []);

  const loginHandler = async (e) => {
    e.preventDefault();
    if (!email) return setError("Please enter email address");
    if (!password) return setError("Please enter password");

    try {
      setLoginLoading(true);
      const response = await axios.post(`${apiurl}/api/user/login`, {
        email,
        password,
      });

      if (!response.data.success) {
        setError(response.data.message);
      } else {
        // Check if 2FA is enabled
        if (response.data.user?.twoFactorAuth?.enabled) {
          // Navigate to OTP page
          navigate("/verify-otp", {
            state: {
              email: response.data.user.email,
              name: `${response.data.user.firstName} ${response.data.user.lastName}`,
              rememberMe,
              redirectTo,
            },
          });
        } else {
          // Direct login
          const token = rememberMe
            ? response.data.refreshToken
            : response.data.accessToken;

          setCookie("swtoken", token, rememberMe ? 2505600 : 25200);
          // navigate("/lander");

          // ✅ go to redirect path if available
          if (redirectTo) {
            navigate(redirectTo);
          } else {
            navigate("/lander");
          }
        }
      }
    } catch (error) {
      setError("Login failed. Please try again.");
    } finally {
      setLoginLoading(false);
    }
  };

  return (
    <div className="w-full min-h-screen flex justify-center bg-[#fffdfc] items-center p-4 md:p-10">
      <div className="w-full max-w-4xl flex flex-col md:flex-row border border-[#39160D] shadow-lg rounded-lg overflow-hidden">
        <div className="w-full md:w-1/2 flex flex-col justify-center p-6">
          <div className="flex justify-center items-center">
            <img
              src="/suwasthi-logo-brown.png"
              alt="Logo"
              className="h-24 mb-6"
              height={100}
            />
          </div>
          <h2 className="text-2xl font-semibold text-gray-800 mb-2 text-center">
            Welcome back!
          </h2>
          <p className="text-gray-500 mb-8 text-center">
            Please login to your account
          </p>

          <form onSubmit={loginHandler} className="space-y-4">
            <div>
              <label className="text-[#575757] font-medium text-sm">
                Email Address
              </label>
              <input
                type="email"
                placeholder="Email"
                className="w-full px-4 py-3 bg-[#f4f2f0] focus:outline-none focus:ring-1 focus:ring-[#d8c9ae] rounded-md"
                value={email}
                // onChange={(e) => {
                //     setEmail(e.target.value);
                //     setError("");
                // }}
                onChange={(e) => {
                  setEmail(e.target.value.toLowerCase()); // ensure lowercase
                  setError("");
                }}
              />
            </div>
            <div>
              <label className="text-[#575757] font-medium text-sm">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  className="w-full px-4 py-3 bg-[#f4f2f0] focus:outline-none focus:ring-1 focus:ring-[#d8c9ae] rounded-md"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setError("");
                  }}
                />
                <button
                  type="button"
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEye /> : <FaEyeSlash />}
                </button>
              </div>
            </div>

            {error && (
              <div className="text-red-500 text-sm flex items-center gap-2">
                <BiError /> {error}
              </div>
            )}

            <div className="flex items-center justify-between">
              <label className="flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                />
                <span className="ml-2 text-sm text-gray-600">Remember Me</span>
              </label>
              <Link
                to="/reset-password"
                className="text-sm text-slate-600 hover:text-[#d8c9ae] font-medium"
              >
                Forgot Password?
              </Link>
            </div>

            <button
              type="submit"
              className="w-full bg-[#39160D] font-semibold text-[#d8c9ae] hover:bg-[#494949] h-11 flex items-center justify-center rounded-md transition duration-200"
              disabled={loginloading}
            >
              {loginloading ? (
                <BlinkLoader />
              ) : (
                <span className="flex items-center">
                  Sign In
                  <GoArrowRight className="ml-2 transition-transform duration-300 group-hover:translate-x-2" />
                </span>
              )}
            </button>
          </form>

          <p className="text-sm text-gray-600 mt-6">
            Don't have an account yet?{" "}
            <Link
              to="/signup"
              className="text-sm text-slate-600 hover:text-[#d8c9ae] font-medium"
            >
              Sign up
            </Link>
          </p>
        </div>

        <div className="hidden md:block md:w-1/2">
          <img
            src="/images/COLLAGE-BANNER.jpg"
            alt="Banner"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default UserLogin;